import {RouteDefinition} from "../../../routes"
import {IntercomListScreen} from "./IntercomListScreen"
import {IntercomEditScreen} from "./IntercomEditScreen"
import {CallListScreen} from "./CallListListScreen"
import {CallListEditScreen} from "./CallListEditScreen"

export const IntercomSettingsRoutes: RouteDefinition[] = [
    {
        routerLink: "/settings/intercom",
        component: IntercomListScreen
    },
    {
        routerLink: "/settings/intercom/edit/:id",
        component: IntercomEditScreen
    },
    {
        routerLink: "/settings/intercom/edit",
        component: IntercomEditScreen
    },
    {
        routerLink: "/settings/intercom/call-list",
        component: CallListScreen
    },
    {
        routerLink: "/settings/intercom/call-list/edit/:id",
        component: CallListEditScreen
    },
    {
        routerLink: "/settings/intercom/call-list/edit",
        component: CallListEditScreen
    }
]
